import AppConstant from '../../../config/app.constants';

class ServiceSettingsChecklistController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, Modal, ServiceChecklistService, BranchService) {
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.ServiceChecklistService = ServiceChecklistService;
        this.BranchService = BranchService;

        this.model = {
            currentBranch: this.User.getUser().branchId,
            serviceChecklist: [],
            originalChecklist: [],
            searchText: '',
            loading: true,
            _loading: false,
            isServiceChecklist: false
        }
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.errorMessage = '';
    }

    $onInit() {
        this.loadPermission();
        this.checkforServiceChecklist();
        this.loadData();
    }

    loadPermission() {
        this.acl = {};
        this.hasServiceCheckListACL = {};

        ['setting-service-checklist'].forEach((permissionKey) => {
            this.acl[permissionKey] = this.User.getACL(permissionKey);
            this.acl[permissionKey].forEach((permission) => {
                this.hasServiceCheckListACL[permission] = true;
            });
        });
    }

    createServiceChecklist() {
        this.Modal.createServiceChecklist(this.pagination.total, ({ modal, serviceChecklist }) => {
            this.ServiceChecklistService.create({ ...serviceChecklist, branchId: this.model.currentBranch })
                .then(() => {
                    setTimeout(() => {
                        this.loadData();
                    });
                    modal.close();
                })
                .catch((err) => {
                    this.Modal.errorModal(err.data.message)
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    generateSearchObj() {
        return {
            queryText: '%' + this.model.searchText + '%',
            isQuery: false
        }
    }

    checkforServiceChecklist() {
        if (this.model.isServiceChecklist) return;
        this.model.loading = true;
        this.BranchService.getBranchSetup(this.model.currentBranch).then((data) => {
            this.model.isServiceChecklist = data.serviceChecklist;
        }).catch((err) => {
            this.error = err.message;
        }).finally(() => {
            this.model.loading = false;
        })
    }

    loadData() {
        this.model.loading = true;
        this.ServiceChecklistService.all(this.generateSearchObj(), (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
            .then((data) => {
                this.pagination.total = data.total;
                this.model.serviceChecklist = angular.copy(data.results); // Mutable array for user changes
                this.model.originalChecklist = Object.freeze(angular.copy(data.results)); // Immutable array for original data
            })
            .catch((err) => {
                this.error = err.message;
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    pageChange() {
        this.loadData();
    }

    updateSortOrder(index) {
        const nextIndexStart = (this.pagination.page - 1) * 10;
        this.model.serviceChecklist.splice(index, 1);
        this.model.serviceChecklist.forEach((item, idx) => {
            item.sortOrder = nextIndexStart + idx + 1;
        });
    };

    removeServiceChecklist(index) {
        if (this.model.serviceChecklist[index].id) {
            this.model.serviceChecklist.splice(index, 1);
        } else {
            this.model.serviceChecklist.splice(index, 1);
        }
    };

    disableCodeUpdate() {
        let isEmpty = this.model.serviceChecklist.filter(item => (!item.label || !item.daySelection));
        return isEmpty.length ? true : false;
    }

    compareArrays(originalArray, changedArray) {
        const changed = [];
        const removed = [];
        const originalMap = new Map();

        originalArray.forEach(item => originalMap.set(item.id, item));
        changedArray.forEach(item => {
            const originalItem = originalMap.get(item.id);
            if (!originalItem) return;

            if (item.label !== originalItem.label || item.sortOrder !== originalItem.sortOrder || item.daySelection !== originalItem.daySelection) {
                changed.push(item);
            }
            originalMap.delete(item.id);
        });

        removed.push(...originalMap.values());
        if (changed.length === 0 && removed.length === 0) {
            return null;
        }
        return { changed, removed };
    }

    updateServiceChecklist(index) {
        if (!this.hasACL['edit']) return;

        this.model.loading = true;
        const serviceChecklist = this.compareArrays(this.model.originalChecklist, this.model.serviceChecklist);
        if (!serviceChecklist) {
            this.model.loading = false;
            return;
        }

        this.ServiceChecklistService.updateServiceChecklist({ serviceChecklist: serviceChecklist.changed, itemRemove: serviceChecklist.removed })
            .then(res => {
                this.loadData();
            })
            .catch(err => {
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
                this.Modal.errorModal(this.errorMessage);
            }).finally(() => {
                this.model.loading = false;
            })
    }
}

export default ServiceSettingsChecklistController;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/service-checklist/service_checklists.controller.js